import type { LearningsAskManager } from '@/state/learnings/useLearningsAsk';
import { AiAskField } from '@/components/ai-chat';
import { LEARNINGS_ASK_TITLE } from './LearningsAskPanel';

type AskFieldProps = { manager: LearningsAskManager };

/**
 * Ask in the row above every Learnings view (decided 2026-10-20, option B1): the shared field the
 * experiment header uses, which turns into the pressed Ink "Ask" while the panel is open, so the
 * two assistants are asked the same way.
 */
export const AskField = ({ manager }: AskFieldProps) => (
  <AiAskField
    open={manager.open}
    onToggle={manager.toggle}
    busy={manager.busy}
    draft={manager.draft}
    onDraftChange={manager.setDraft}
    onSubmit={manager.submitFromField}
    label={LEARNINGS_ASK_TITLE}
    placeholder={LEARNINGS_ASK_TITLE}
    tourAnchor="learnings-ask"
  />
);
